import {
  DOCSEAL_TEMPLATE_URL,
  get_headers
} from "@/utils/constants/constants";
import { DocusealBuilder } from "@docuseal/vue";
import NavigationBackButton from "@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue";
import alert_mixin from "@/utils/mixins/alert_mixin";
export default {
  name: "ConfigureTemplate",
  mixins: [alert_mixin],
  components: {
    DocusealBuilder,
    NavigationBackButton,
  },

  data: () => ({
    token: "",
    headers: get_headers(),
    template_id: null,
    isLoading: true,
    is_fetching: false,
    assigned_tags: [],
    docuseal_fields: [],
    combined_fields: [],
    builderKey: 0,
    roles: [],
  }),

  created() {
    //Capture ID from params or query
    this.template_id = this.$route.params.template_id || this.$route.query.template_id;
  },

  watch: {
    //Watch for route param changes
    "$route.params.template_id"(new_val, old_val) {
      if (new_val && new_val !== old_val) {
        this.template_id = new_val;
        this.load_template_configuration();
      }
    },
  },

  mounted() {
    if (this.template_id) {
      this.load_template_configuration();
    } else {
      this.isLoading = false;
    }
  },

  methods: {
    //Prevent duplicate backend calls
    async load_template_configuration() {
      if (this.is_fetching) return;
      this.is_fetching = true;


      try {
        const response = await fetch(DOCSEAL_TEMPLATE_URL, {
          headers: this.headers,
              method: "POST",
              body: JSON.stringify({ template_id: this.template_id }),
            });


            const data = await response.json();

            if (data.status === "success") {
              this.token = data.data.token;
              this.process_backend_tags(data.data.tags || []);
              this.roles = data.data.roles
            } else {
              this.show_error(data.message || "Failed to load template");
            }
          } catch (error) {
            this.show_error(error.message || "Failed to load template configuration");
          } finally {
            this.is_fetching = false;
            this.isLoading = false;
            this.builderKey++;
          }
    },


    process_backend_tags(tags) {
      let backend_tags = [];
      if (tags) {
        try {
          backend_tags = typeof tags === "string" ? JSON.parse(tags) : tags;
          if (!Array.isArray(backend_tags)) backend_tags = [backend_tags];
        } catch {
          backend_tags = [];
        }
      }

      this.assigned_tags = backend_tags;

      const tag_fields = backend_tags.map((tag, index) => {
        const is_object = typeof tag === "object";
        return {
          name: is_object ? tag.name || tag.label || tag : tag,
          type: is_object ? tag.type || "text" : "text",
          role: tag.role,
          x: 100 + (index % 5) * 220,
          y: 100 + Math.floor(index / 5) * 60,
          width: 200,
          height: 30,
          required: is_object ? tag.required !== false : true,
          readonly: is_object ? tag.readonly === true : false,
        };
      });

      
      this.combined_fields = tag_fields

    },

    on_fields_update(fields) {
      this.combined_fields = fields;
    },
  },
};
